import { useEffect, useState } from "react";
import { VerificationTabs } from "./verificationTabs";
import { Identification } from "./identification";
import { Banking } from "./Banking/Banking";
import { userPendingStore } from "../../users/store/userPendingData.store";

export function Verification() {
  const [activeTab, setActiveTab] = useState("identification");

  const onTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    userPendingStore.getState().fetchPendingData();
  }, []);

  let content = null;
  switch (activeTab) {
    case "identification":
      content = <Identification />;
      break;
    case "banking":
      content = <Banking />;
      break;
  }

  return (
    <div className="lg:max-w-[95%] mx-auto">
      <VerificationTabs activeTab={activeTab} onTabChange={onTabChange} />
      <div className="p-4">{content}</div>
    </div>
  );
}
